export enum CampaignTypeEnum {
  simple = 1,
  scheduled = 2,
  event = 3,
  abTest = 4,
}
